export default __webpack_public_path__ + "static/media/stone.aaa77a40.png";